import { ViewConfig } from "@lib/views";
import type { SendingEmailWithDomain } from "@api/sendingEmail.api";
import { DefaultCell } from "./cells/DefaultCell";
import { DisplayNameCell } from "./cells/DisplayNameCell";
import { EmailDomainCell } from "./cells/EmailDomainCell";
import { SendingEmailActionsCell } from "./cells/SendingEmailActionsCell";
import { SendingEmailCell } from "./cells/SendingEmailCell";
import { SendingEmailEntitiesCell } from "./cells/SendingEmailEntitiesCell";

export enum SendingEmailColumn {
    EMAIL = "email",
    DISPLAY_NAME = "displayName",
    DOMAIN = "domain",
    ENTITIES = "entityUuids",
    DEFAULT = "isDefault",
    ACTIONS = "actions",
}

export const SUGGESTED_SENDING_EMAIL_ROW_ID = "suggested-custom-sender";

export interface SuggestedSendingEmailRow {
    id: typeof SUGGESTED_SENDING_EMAIL_ROW_ID;
    email: string;
    displayName: null;
    domain: string;
    isDefault: false;
    isVerified: false;
    isSuggested: true;
}

export type SendingEmailRow = SendingEmailWithDomain | SuggestedSendingEmailRow;

export function isSuggestedSendingEmailRow(
    row: SendingEmailRow,
): row is SuggestedSendingEmailRow {
    return "isSuggested" in row && row.isSuggested;
}

export const sendingEmailsViewConfig: ViewConfig<
    SendingEmailRow,
    SendingEmailColumn,
    never
> = {
    columns: {
        [SendingEmailColumn.EMAIL]: {
            accessorKey: "email",
            name: "Email",
            header: "Email",
            cell: SendingEmailCell,
            minSize: 200,
            maxSize: 1000,
        },
        [SendingEmailColumn.DISPLAY_NAME]: {
            accessorKey: "displayName",
            name: "Display name",
            header: "Display name",
            cell: DisplayNameCell,
            minSize: 140,
            maxSize: 320,
        },
        [SendingEmailColumn.DOMAIN]: {
            accessorKey: "domain",
            name: "Domain",
            header: "Domain",
            cell: EmailDomainCell,
            minSize: 140,
            maxSize: 280,
        },
        [SendingEmailColumn.ENTITIES]: {
            accessorKey: "entityUuids",
            name: "Entities",
            header: "Entities",
            cell: SendingEmailEntitiesCell,
            minSize: 120,
            maxSize: 240,
        },
        [SendingEmailColumn.DEFAULT]: {
            accessorKey: "isDefault",
            name: "Default",
            header: "Default",
            cell: DefaultCell,
            minSize: 90,
            maxSize: 120,
        },
        [SendingEmailColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: SendingEmailActionsCell,
            align: "right",
            minSize: 100,
            maxSize: 120,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
